function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   @font-face {\n      font-family: SharpSans;\n      src: url(", ");\n   }\n\n   @font-face {\n      font-family: SharpSansSemiBold;\n      src: url(", ");\n   }\n\n   @font-face {\n      font-family: SharpSansBold;\n      src: url(", ");\n   }\n\n   body {\n      margin: 0;\n      font-family: SharpSans, sans-serif;\n      background-color: ", ";\n   }\n\n   * {\n      outline-color: ", ";\n   }\n\n   *,\n   *::before,\n   *::after {\n      box-sizing: border-box;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { createGlobalStyle } from 'styled-components';
import sharpSansFont from './globalBaseStyles/SharpSansNo2-Book.otf';
import sharpSansSemiBoldFont from './globalBaseStyles/SharpSansNo2-Semibold.otf';
import sharpSansBoldFont from './globalBaseStyles/SharpSansNo2-Bold.otf';
var GlobalBaseStyles = createGlobalStyle(_templateObject(), sharpSansFont, sharpSansSemiBoldFont, sharpSansBoldFont, function (_ref) {
  var theme = _ref.theme;
  return theme.semanticColors.siteBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColors.purple;
});
export { GlobalBaseStyles };